import React from 'react';

import { AlertTriangle, MapPin } from 'lucide-react';

import { Button, Input } from '@/_components';


import { AddressBlock, RecommendedAddressBlock } from './address-blocks';
import type { EnteredAddressSnapshot } from './address-blocks';

import type { AddressValidationResponse } from '../../shared';

type SubpremisesContentProps = {
  enteredAddress: EnteredAddressSnapshot | null;
  result: AddressValidationResponse;
  onKeepCurrent: () => void;
  onUseRecommendedWithUnit: (unit: string) => void;
};

export function SubpremisesContent({
  enteredAddress,
  result,
  onKeepCurrent,
  onUseRecommendedWithUnit,
}: SubpremisesContentProps) {
  const [unitNumber, setUnitNumber] = React.useState('');

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      {enteredAddress && (
        <section className="border-c-border flex flex-col justify-between rounded-xl border-2 p-4">
          <div>
            <div className="mb-2 flex items-center gap-2">
              <MapPin className="text-c-card-muted h-4 w-4" />
              <h6 className="text-base font-semibold">You Entered</h6>
            </div>
            <AddressBlock
              line1={enteredAddress.address1}
              line2={enteredAddress.address2}
              cityStateZip={[enteredAddress.city, enteredAddress.state, enteredAddress.postalCode]
                .filter(Boolean)
                .join(', ')}
              country={enteredAddress.country}
            />
          </div>
          <div className="mt-4">
            <Button as="outline" size="sm" className="w-full" onClick={onKeepCurrent}>
              Keep Current
            </Button>
          </div>
        </section>
      )}
      <section className="border-warning rounded-xl border-2 p-4">
        <div className="mb-2 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <AlertTriangle className="text-warning h-4 w-4" />
            <h6 className="text-base font-semibold">USPS Partial Match</h6>
          </div>
        </div>
        <RecommendedAddressBlock result={result} />
        <div className="mt-4">
          <Input
            label="Apartment / Unit # (required)"
            placeholder="e.g. APT 4B, STE 200"
            value={unitNumber}
            onChange={(e) => setUnitNumber(e.target.value)}
          />
        </div>
        <div className="mt-4">
          <Button
            as="contained"
            size="sm"
            className="w-full"
            disabled={!unitNumber.trim()}
            onClick={() => onUseRecommendedWithUnit(unitNumber)}
          >
            Update &amp; Confirm
          </Button>
        </div>
      </section>
    </div>
  );
}
